import '../social_content_previous_comments_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.TikTokContentPreviousCommentsView extends Monitoring.Views.SocialContentPreviousCommentsView

  buildQuery: =>
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    @searchQuery.addContextKind('previous_comments')
    # @searchQuery.addParentPostId(@rootParentId)
    # @searchQuery.addImmediateParentId(@immediateParentId)
    @searchQuery.addChildCommentsFor(@socialContent.rootPostId())
    @searchQuery.addSubtype('tiktok-comment')
    @addContextLimit()
    dateTo = Date.create(@socialContent.created_at()).getTime()
    dateFrom = dateTo - (1000 * 60 * 60 * 24 * 365 * 2) # 2 years ago. The ideal would be the created_at of the parent post
    @searchQuery.addDateTo(dateTo)
    @searchQuery.addDateFrom(dateFrom)
    @searchQuery.setNowDate(false)
